<div class="version-container p-1">v: {{version}}, lm: {{lastModified}}, s: {{ releaseStage }}</div>
